import React from 'react';
import PropTypes from 'prop-types';
import Hyperlink from '../Hyperlink';
import './TopBar.css';

/**
 * TopBar Component
 *
 * Dark bar displayed above the Header with a centered notice message
 * and right-aligned navigation links (desktop only).
 *
 * Figma node: 3848:18424
 * Variants: CLS/ABC × Desktop/Mobile (responsive via CSS media queries)
 */

const DEFAULT_CONTENT = {
  CLS: {
    notice: 'MORE THAN 75,000 CUSTOMERS ANNUALLY',
    links: [
      { label: 'FAQ', href: '#' },
      { label: 'CUSTOMER SERVICE', href: '#' },
    ],
  },
  ABC: {
    notice: 'MORE THAN 75,000 CUSTOMERS ANNUALLY',
    links: [
      { label: 'FAQ', href: '#' },
      { label: 'CUSTOMER SERVICE', href: '#' },
    ],
  },
};

const TopBar = ({
  brand = 'CLS',
  notice,
  links,
  className = '',
}) => {
  const content = DEFAULT_CONTENT[brand] || DEFAULT_CONTENT.CLS;
  const noticeText = notice || content.notice;
  const navLinks = links || content.links;

  const rootClasses = ['ds-topbar', className].filter(Boolean).join(' ');

  return (
    <div className={rootClasses}>
      <div className="ds-topbar__inner">
        <span className="ds-topbar__notice typo-body-sm">{noticeText}</span>
        <div className="ds-topbar__links">
          {navLinks.map((link) => (
            <Hyperlink
              key={link.label}
              href={link.href || '#'}
              variant="small"
              className="ds-topbar__link"
            >
              {link.label}
            </Hyperlink>
          ))}
        </div>
      </div>
    </div>
  );
};

TopBar.propTypes = {
  /** Brand determines default content (notice text, links) */
  brand: PropTypes.oneOf(['CLS', 'ABC', 'Overall']),
  /** Override the default notice text */
  notice: PropTypes.string,
  /** Override the default links array */
  links: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      href: PropTypes.string,
    }),
  ),
  className: PropTypes.string,
};

export default TopBar;
